import React, { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { navLinks, profile } from "../mock/mock";
import { Button } from "./ui/button";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (href) => {
    setOpen(false);
    if (href.startsWith("#")) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.location.href = href;
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#FAFAF7]/85 backdrop-blur-md border-b border-[#E5E5E0]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2 group"
        >
          <span className="font-display text-xl md:text-2xl font-medium tracking-tight">
            Predrag<span className="text-[#0A0A0A]">.</span>
          </span>
          <span className="hidden md:inline-block font-mono text-[10px] uppercase tracking-[0.18em] text-[#6b6b66] mt-1">
            ai·seo·geo·aeo
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {navLinks.map((l) => (
            <button
              key={l.href}
              onClick={() => handleNav(l.href)}
              className="link-underline text-sm font-medium text-[#1a1a1a] hover:text-[#0A0A0A] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <span className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-wider text-[#3d3d3a]">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#7BC400] opacity-60"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-[#7BC400]"></span>
            </span>
            Booking Q3/Q4
          </span>
          <Button
            onClick={() => handleNav("#contact")}
            className="btn-press rounded-full bg-[#0A0A0A] hover:bg-[#1f1f1f] text-[#FAFAF7] px-5 h-10 text-sm font-medium gap-2"
          >
            Start a project
            <ArrowUpRight className="h-4 w-4" />
          </Button>
        </div>

        <button
          aria-label="Menu"
          className="lg:hidden p-2 -mr-2 text-[#0A0A0A]"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#E5E5E0] bg-[#FAFAF7]">
          <div className="px-6 py-6 flex flex-col gap-1">
            {navLinks.map((l) => (
              <button
                key={l.href}
                onClick={() => handleNav(l.href)}
                className="text-left py-3 text-base font-medium border-b border-[#EFEFEA]"
              >
                {l.label}
              </button>
            ))}
            <Button
              onClick={() => handleNav("#contact")}
              className="btn-press mt-5 rounded-full bg-[#0A0A0A] hover:bg-[#1f1f1f] text-[#FAFAF7] h-12 text-sm font-medium gap-2"
            >
              Start a project <ArrowUpRight className="h-4 w-4" />
            </Button>
            <p className="font-mono text-[11px] uppercase tracking-wider text-[#6b6b66] mt-4">
              {profile.email}
            </p>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
